import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { PersistOptions } from "zustand/middleware";
import type { Mode, Theme } from "~/components/ui/utils/theme-provider";

export interface UiThemeState {
  mode: Mode;
  theme: Theme;

  setMode: (mode: Mode) => void;
  setTheme: (mode: Theme) => void;

  reset: () => void;
}

const useUiThemeState = create<UiThemeState>()(
  persist(
    (set, _) => ({
      mode: "dark",
      theme: "zinc",

      setMode: (mode: Mode) => set(() => ({ mode: mode as Mode })),
      setTheme: (theme: Theme) => set(() => ({ theme: theme as Theme })),

      reset: () =>
        set(() => ({
          mode: "system",
          theme: "blue",
        })),
    }),
    {
      name: "ui-theme-state",
    } as PersistOptions<UiThemeState>,
  ),
);

export default useUiThemeState;
